if (!customElements.get("dbtfy-upsell-bundles")) {
  customElements.define(
    "dbtfy-upsell-bundles",
    class extends HTMLElement {
      constructor() {
        super();
      }

      disconnectedCallback() {}

      connectedCallback() {
        this.loadBundle();
      }

      loadBundle() {
        this.setupVars();

        if (this.specificBundle) {
          if (this.upsellItem) {
            this.setUpSpecificBundle();
            this.init();
          } else {
            this.remove();
          }
        } else {
          this.loadRecommendations();
        }
      }

      setupVars() {
        ({
          productId: this.productId,
          productHandler: this.productHandler,
          sectionId: this.sectionId,
          url: this.url,
          specificBundle: this.specificBundle,
          discountAmount: this.discountAmount,
          discountName: this.discountName,
          discountType: this.discountType,
          currency: this.currency,
          formId: this.formId,
          mobileMode: this.mobileMode
        } = this.dataset);

        const matchedBlocks = Debutify.widgets.upsell_bundles.blocks.filter(
          (block) => block.product_trigger === this.productHandler
        );

        this.upsellItem =
          matchedBlocks.length > 0
            ? matchedBlocks[matchedBlocks.length - 1]
            : null;

        this.url = `${this.url}&product_id=${this.productId}&section_id=${this.sectionId}`;

        if (this.upsellItem) {
          this.specificBundle = true;
          this.discountName = this.upsellItem.discount_code;
          this.discountAmount = this.upsellItem.discount_amount;
          this.discountType = this.upsellItem.discount_type;

          if (this.discountType == "$") {
            this.discountAmount = this.discountAmount * 100;
          }

          this.querySelector("product-form")?.setAttribute(
            "data-discount-code",
            this.upsellItem.discount_code
          );
        } else {
          this.specificBundle = this.specificBundle == "false";
        }

        this.discount = {
          name: this.discountName,
          amount: Number(this.discountAmount) || 0,
          type: this.discountType
        };

        this.items = this.querySelectorAll(".dbtfy-upsell-bundles__item");
        this.currency = this.currency;
        this.submitButton = this.querySelector(".product-form__submit");
        this.formInput = this.querySelector(".product-variant-id");
        this.selects = this.querySelectorAll('[name="id[]"]');
        this.wrapper = document.getElementById(
          "dbtfy-upsell-bundles-wrapper"
        );
      }

      async setUpSpecificBundle() {
        const extraItems = this.querySelectorAll(
          ".dbtfy-upsell-bundle__list .dbtfy-upsell-bundles__item:nth-child(n+2)"
        );

        extraItems?.forEach((item) => {
          item.remove();
        });

        if (this.upsellItem.product_offer_1) {
          await this.loadSpecificItem(this.upsellItem.product_offer_1);
        }

        if (this.upsellItem.product_offer_2) {
          await this.loadSpecificItem(this.upsellItem.product_offer_2);
        }

        if (this.upsellItem.product_offer_3) {
          await this.loadSpecificItem(this.upsellItem.product_offer_3);
        }

        this.setupVars();
        this.init();
      }

      async loadSpecificItem(handle) {
        let markup = await Debutify.fetchProductMarkup(
          `/products/${handle}?view=internal-upsell-item`
        );

        const doc = new DOMParser().parseFromString(markup, "text/html");
        const item = doc.querySelector(".dbtfy-upsell-bundles__item");
        const itemForMobile = doc.querySelector(".dbtfy-upsell-bundles__item");

        if (itemForMobile && this.mobileMode == "true") {
          itemForMobile.classList.remove(
            "grid--6-col-desktop",
            "grid--6-col-tablet"
          );
        }

        if (item) {
          item
            .querySelectorAll("select")
            .forEach((select) =>
              select.setAttribute("form", this.formId)
            );

          item
            .querySelectorAll('input[type="radio"]')
            .forEach((input) =>
              input.setAttribute("form", this.formId)
            );

          this.querySelector(".dbtfy-upsell-bundle__list")?.appendChild(
            item
          );
        }
      }

      loadRecommendations() {
        fetch(this.url)
          .then((res) => res.text())
          .then((html) => {
            const wrapper = document.createElement("div");
            wrapper.innerHTML = html;

            const upsellEl = wrapper.querySelector("dbtfy-upsell-bundles");

            if (
              upsellEl &&
              upsellEl.querySelectorAll(".dbtfy-upsell-bundles__item")
                .length > 1 &&
              upsellEl?.innerHTML.trim().length
            ) {
              this.innerHTML = upsellEl.innerHTML;
              this.items = this.querySelectorAll(
                ".dbtfy-upsell-bundles__item"
              );
              this.submitButton =
                this.querySelector(".product-form__submit");
              this.formInput =
                this.querySelector(".product-variant-id");
              this.selects = this.querySelectorAll('[name="id[]"]');

              this.init();
              this.removeAttribute("hidden");
            }
          })
          .catch((err) => {
            console.error(err);
          });
      }

      init() {
        this.removeAttribute("hidden");

        this.formInput.setAttribute("name", "id[]");
        this.formInput.disabled = true;

        this.selects.forEach((select) => {
          select.addEventListener(
            "change",
            this.updateItems.bind(this)
          );
          select.addEventListener(
            "change",
            this.setTotalPrice.bind(this)
          );
        });

        this.updateItems();
        this.setTotalPrice();
        this.addEventToCheckbox();

        this.setAttribute("data-insert-product", true);
      }

      setTotalPrice() {
        let total = 0;
        let discountedTotal = 0;
        let savings = 0;
        let discountAmount = this.discount.amount;

        // If only 1 item is selected, no discount
        if (
          this.querySelectorAll(
            ".dbtfy-upsell-bundles__item .dbtfy-upsell-product-item__checkbox:checked"
          ).length == 1
        ) {
          discountAmount = 0;
        }

        this.items.forEach((item) => {
          const select = item.querySelector('[name="id[]"]');

          if (!select.disabled) {
            const variant = this.getCurrentVariant(item)[0];
            total += variant.price;
          }
        });

        if (this.discount.type == "%") {
          discountedTotal = Math.trunc(
            total * ((100 - discountAmount) / 100)
          );
        } else {
          discountedTotal = total - discountAmount;
        }

        savings = total - discountedTotal;

        if (discountedTotal < 0) {
          savings = total;
          discountedTotal = 0;
        }

        // 🔴 CHANGED: textContent → innerHTML
        const discountPriceEl = this.querySelector(
          ".dbtfy-upsell-bundles__discount-price"
        );
        const originalPriceEl = this.querySelector(
          ".dbtfy-upsell-bundles__original-price"
        );
        const savePriceEl = this.querySelector(
          ".dbtfy-upsell-bundles__save-price"
        );

        if (discountPriceEl) {
          discountPriceEl.innerHTML =
            total > 0 ? this.moneyFormat(discountedTotal) : "";
        }

        if (originalPriceEl) {
          originalPriceEl.innerHTML =
            total > discountedTotal ? this.moneyFormat(total) : "";
        }

        if (savePriceEl) {
          savePriceEl.innerHTML =
            savings > 0
              ? `SAVE ${this.moneyFormat(savings)}`
              : "";
        }

        this.submitButton.disabled = total == 0;
      }

      updateItems() {
        this.items.forEach((item, index) => {
          const product = this.getProduct(item);
          const variant = this.getCurrentVariant(item)[0];
          const titleEl = item.querySelector(
            ".bundle__title .product-title"
          );

          const price = variant.price;
          const compareAt = variant.compare_at_price || 0;

          let titleHtml = `${product.title} | `;

          if (index > 0) {
            titleHtml = `<label for="dbtfy-upsell-product-item--${product.id}">${product.title}</label> | `;
          }

          titleEl.innerHTML = `${titleHtml}${
            variant.title && variant.title !== "Default Title"
              ? variant.title + " | "
              : ""
          }${this.moneyFormat(price)}${
            compareAt > price
              ? " <del>" + this.moneyFormat(compareAt) + "</del>"
              : ""
          }`;
        });
      }

      getProduct(item) {
        return JSON.parse(
          item.querySelector("[data-product]").innerHTML
        );
      }

      getCurrentVariant(item) {
        const product = this.getProduct(item);
        const variantId = item.querySelector('[name="id[]"]').value;

        return product.variants.filter(
          (variant) => variant.id == variantId
        );
      }

      moneyFormat(amount) {
        let formatted = Shopify.formatMoney(amount);

        if (Shopify.dummyAmount.includes(".")) {
          formatted = formatted.replace(/,/g, ".");
        }

        return formatted;
      }

      addEventToCheckbox() {
        this.items.forEach((item) => {
          const checkbox = item.querySelector(
            ".dbtfy-upsell-product-item__checkbox"
          );

          checkbox.addEventListener("change", (event) => {
            const target = event.target;

            target
              .closest(".dbtfy-upsell-bundles__item")
              .querySelector('[name="id[]"]').disabled =
              !target.checked;

            this.querySelector(
              `.dbtfy-upsell-bundle__media[data-product-id="${target.value}"]`
            )?.classList.toggle("disabled");

            this.setTotalPrice();
          });
        });

        this.items.forEach((item) => {
          item
            .querySelector(".custom_checkbox")
            ?.addEventListener("click", (event) => {
              event.preventDefault();

              const checkbox = event.target
                .closest(".dbtfy-upsell-bundles__item")
                .querySelector(
                  ".dbtfy-upsell-product-item__checkbox"
                );

              checkbox.checked = !checkbox.checked;
              checkbox.dispatchEvent(
                new Event("change", { bubbles: true })
              );
            });
        });
      }
    }
  );
}
